export const common = {
  client: 'uwf',
  shiny_url: 'programchange',
  logo_paths: {
    primary: '',
    secondary: '',
    word_mark: '',

    // Home page cards
    homepageSuccessMetricsStudentCohortProfile:
      '../assets/uwf_assets/homepage-success-metrics-pics/studentCohortAtRisk.png',

    // About homepage icons
    homepageAdminSupport:
      '../assets/uwf_assets/homepage-admin-support-pics/adminSupport.png',
    homepageFinancialAid:
      '../assets/uwf_assets/homepage-financial-aid-pics/financialAid.png',
    homepageEnrollmentRetention:
      '../assets/uwf_assets/homepage-enrollment-retention-pics/enrollmentRetention.png',
    homepageSuccessMetrics:
      '../assets/uwf_assets/homepage-success-metrics-pics/successMetrics.png',

    // Success metrics homepage icons
    homepageCourseRecommenderEstimation:
      '../assets/uwf_assets/homepage-course-estimation-recommender-pics/coursesRecommender.png',
    homepageCoursesExplorer:
      '../assets/uwf_assets/homepage-courses-explorer-pics/coursesExplorer.png',
    homepageStudentCohortProfileAtRisk:
      '../assets/uwf_assets/homepage-success-metrics-pics/studentCohortAtRisk.png',

    // Student cohort profile at-risk homepage icons
    homepageStudentCohortProfile:
      '../assets/uwf_assets/homepage-success-metrics-pics/studentCohortProfile.png',
    homepageAtRiskStudent:
      '../assets/uwf_assets/homepage-success-metrics-pics/atRiskStudent.png',

    // Courses explorer homepage icons
    homepageCourseCombinations:
      '../assets/uwf_assets/homepage-courses-explorer-pics/courseCombinations.png',
    homepageCourseRank:
      '../assets/uwf_assets/homepage-courses-explorer-pics/courseRank.png',
    homepagePrerequisiteImpact:
      '../assets/uwf_assets/homepage-courses-explorer-pics/prerequisiteImpact.png',
    homepageProgramBottleneck:
      '../assets/uwf_assets/homepage-courses-explorer-pics/programBottleneckCourses.png',

    // Courses estimation/recommender homepage icons
    homepageCourseRecommender:
      '../assets/uwf_assets/homepage-course-estimation-recommender-pics/courseRecommender.png',
    homepageCourseGradeEstimation:
      '../assets/uwf_assets/homepage-course-estimation-recommender-pics/courseGradeEstimation.png',

    // Enrollment retention homepage icons
    homepageEnrollmentRetentionTool:
      '../assets/uwf_assets/homepage-enrollment-retention-pics/enrollmentRetentionTool.png',
    homepageEnrollmentTrend:
      '../assets/uwf_assets/homepage-enrollment-retention-pics/enrollmentTrend.png',

    // Financial aid homepage icons
    homepageFinancialAidTool:
      '../assets/uwf_assets/homepage-financial-aid-pics/financialAidTool.png',
    homepageTypesOfFinancialAid:
      '../assets/uwf_assets/homepage-financial-aid-pics/typesOfFinancialAid.png',

    // Admin support homepage icons
    homepageAprGraduationSummary:
      '../assets/uwf_assets/homepage-admin-support-pics/aprGraduationSummary.png',
    homepageExitFlowCourseGradesScore:
      '../assets/uwf_assets/homepage-exit-flow-course-grade-pics/exitGraphCourseGradesScore.png',
    homepageNewApplicantsDir:
      '../assets/uwf_assets/homepage-new-applicants-pics/newApplicantsDir.png',
    homepageTransferOverview:
      '../assets/uwf_assets/homepage-admin-support-pics/transferOverview.png',

    // Exit flow course grade score homepage icons
    homepageExitEntryFlowGraph:
      '../assets/uwf_assets/homepage-exit-flow-course-grade-pics/exitEntryFlowGraph.png',

    // New applicants homepage icons
    homepageNewApplicants:
      '../assets/uwf_assets/homepage-new-applicants-pics/newApplicants.png',
    // homepageExploreTierCharacteristics:
    //   '../assets/uwf_assets/homepage-new-applicants-pics/exploreTierCharacteristics.png',
    // homepagePredictingAcademicSuccess:
    //   '../assets/uwf_assets/homepage-new-applicants-pics/predictingAcademicSuccess.png',

    // Courses Analysis homepage icons
    homepageFticDwfApr:
      '../assets/uwf_assets/homepage-exit-flow-course-grade-pics/courseGrades.png',
    homepageCriticalCourseScore:
      '../assets/uwf_assets/homepage-exit-flow-course-grade-pics/criticalCourseScore.png',

    // Help pages student guide
    helpPageStudentFig11:
      '../assets/uwf_assets/dashboard-guide-pics/student-profile-guide/Figure11.png',
    helpPageStudentFig11a:
      '../assets/uwf_assets/dashboard-guide-pics/student-profile-guide/Figure11a.png',
    helpPageStudentFig12:
      '../assets/uwf_assets/dashboard-guide-pics/student-profile-guide/Figure12.png',
    helpPageStudentFig12a:
      '../assets/uwf_assets/dashboard-guide-pics/student-profile-guide/Figure12a.png',
    helpPageStudentFig12b:
      '../assets/uwf_assets/dashboard-guide-pics/student-profile-guide/Figure12b.png',
    helpPageStudentFig12c:
      '../assets/uwf_assets/dashboard-guide-pics/student-profile-guide/Figure12c.png',
    helpPageStudentFig12d:
      '../assets/uwf_assets/dashboard-guide-pics/student-profile-guide/Figure12d.png',
    helpPageStudentFig12e:
      '../assets/uwf_assets/dashboard-guide-pics/student-profile-guide/Figure12e.png',
    helpPageStudentFig12f:
      '../assets/uwf_assets/dashboard-guide-pics/student-profile-guide/Figure12f.png',
    helpPageStudentFig12g:
      '../assets/uwf_assets/dashboard-guide-pics/student-profile-guide/Figure12g.png',
    helpPageStudentFig12h:
      '../assets/uwf_assets/dashboard-guide-pics/student-profile-guide/Figure12h.png',
    helpPageStudentFig12i:
      '../assets/uwf_assets/dashboard-guide-pics/student-profile-guide/Figure12i.png',
    helpPageStudentFig12j:
      '../assets/uwf_assets/dashboard-guide-pics/student-profile-guide/Figure12j.png',
    helpPageStudentFig12k:
      '../assets/uwf_assets/dashboard-guide-pics/student-profile-guide/Figure12k.png',

    helpPageStudentFig13:
      '../assets/uwf_assets/dashboard-guide-pics/student-profile-guide/Figure13.png',
    helpPageStudentFig13a:
      '../assets/uwf_assets/dashboard-guide-pics/student-profile-guide/Figure13a.png',

    // Help pages cohort guide
    helpPageCohortFig14:
      '../assets/uwf_assets/dashboard-guide-pics/cohort-profile-guide/Figure14.png',
    helpPageCohortFig14a:
      '../assets/uwf_assets/dashboard-guide-pics/cohort-profile-guide/Figure14a.png',
    helpPageCohortFig14b:
      '../assets/uwf_assets/dashboard-guide-pics/cohort-profile-guide/Figure14b.png',
    helpPageCohortFig15:
      '../assets/uwf_assets/dashboard-guide-pics/cohort-profile-guide/Figure15.png',
    helpPageCohortFig15a:
      '../assets/uwf_assets/dashboard-guide-pics/cohort-profile-guide/Figure15a.png',
    helpPageCohortFig15b:
      '../assets/uwf_assets/dashboard-guide-pics/cohort-profile-guide/Figure15b.png',
    helpPageCohortFig16:
      '../assets/uwf_assets/dashboard-guide-pics/cohort-profile-guide/Figure16.png',
    helpPageCohortFig16a:
      '../assets/uwf_assets/dashboard-guide-pics/cohort-profile-guide/Figure16a.png',
    helpPageCohortFig16b:
      '../assets/uwf_assets/dashboard-guide-pics/cohort-profile-guide/Figure16b.png',
    helpPageCohortFig16c:
      '../assets/uwf_assets/dashboard-guide-pics/cohort-profile-guide/Figure16c.png',

    // Help pages at-risk guide
    helpPageAtRiskFig17:
      '../assets/uwf_assets/dashboard-guide-pics/advisor-at-risk-guide/Figure17.png',
    helpPageAtRiskFig17a:
      '../assets/uwf_assets/dashboard-guide-pics/advisor-at-risk-guide/Figure17a.png',
    helpPageAtRiskFig17b:
      '../assets/uwf_assets/dashboard-guide-pics/advisor-at-risk-guide/Figure17b.png',

    // Help pages course combinations guide
    helpPageCourseCombinationsFig18:
      '../assets/uwf_assets/dashboard-guide-pics/course-combinations-guide/Figure18.png',
    helpPageCourseCombinationsFig18a:
      '../assets/uwf_assets/dashboard-guide-pics/course-combinations-guide/Figure18a.png',
    helpPageCourseCombinationsFig19:
      '../assets/uwf_assets/dashboard-guide-pics/course-combinations-guide/Figure19.png',
    helpPageCourseCombinationsFig19a:
      '../assets/uwf_assets/dashboard-guide-pics/course-combinations-guide/Figure19a.png',

    // Help pages prerequisite impact guide
    helpPagePrereqImpactFig20:
      '../assets/uwf_assets/dashboard-guide-pics/prerequisite-impact-guide/Figure20.png',
    helpPagePrereqImpactFig20a:
      '../assets/uwf_assets/dashboard-guide-pics/prerequisite-impact-guide/Figure20a.png',
    helpPagePrereqImpactFig20b:
      '../assets/uwf_assets/dashboard-guide-pics/prerequisite-impact-guide/Figure20b.png',
    helpPagePrereqImpactFig21:
      '../assets/uwf_assets/dashboard-guide-pics/prerequisite-impact-guide/Figure21.png',
    helpPagePrereqImpactFig22:
      '../assets/uwf_assets/dashboard-guide-pics/prerequisite-impact-guide/Figure22.png',
    helpPagePrereqImpactFig22a:
      '../assets/uwf_assets/dashboard-guide-pics/prerequisite-impact-guide/Figure22a.png',

    // Help pages program bottleneck courses guide
    helpPageProgramBottleneckFig23:
      '../assets/uwf_assets/dashboard-guide-pics/program-bottleneck-guide/Figure23.png',
    helpPageProgramBottleneckFig23a:
      '../assets/uwf_assets/dashboard-guide-pics/program-bottleneck-guide/Figure23a.png',
    helpPageProgramBottleneckFig24:
      '../assets/uwf_assets/dashboard-guide-pics/program-bottleneck-guide/Figure24.png',

    // Help pages course recommender guide
    helpPageCourseRecommenderFig25:
      '../assets/uwf_assets/dashboard-guide-pics/course-recommender-guide/Figure25.png',
    helpPageCourseRecommenderFig26:
      '../assets/uwf_assets/dashboard-guide-pics/course-recommender-guide/Figure26.png',
    helpPageCourseRecommenderFig26a:
      '../assets/uwf_assets/dashboard-guide-pics/course-recommender-guide/Figure26a.png',
    helpPageCourseRecommenderFig26b:
      '../assets/uwf_assets/dashboard-guide-pics/course-recommender-guide/Figure26b.png',
    helpPageCourseRecommenderFig26c:
      '../assets/uwf_assets/dashboard-guide-pics/course-recommender-guide/Figure26c.png',
    helpPageCourseRecommenderFig27:
      '../assets/uwf_assets/dashboard-guide-pics/course-recommender-guide/Figure27.png',

    // Help pages course grade estimation guide
    helpPageCourseEstimationFig28:
      '../assets/uwf_assets/dashboard-guide-pics/course-estimation-guide/Figure28.png',
    helpPageCourseEstimationFig29:
      '../assets/uwf_assets/dashboard-guide-pics/course-estimation-guide/Figure29.png',
    helpPageCourseEstimationFig29a:
      '../assets/uwf_assets/dashboard-guide-pics/course-estimation-guide/Figure29a.png',
    helpPageCourseEstimationFig29b:
      '../assets/uwf_assets/dashboard-guide-pics/course-estimation-guide/Figure29b.png',
    helpPageCourseEstimationFig30:
      '../assets/uwf_assets/dashboard-guide-pics/course-estimation-guide/Figure30.png',

    // Help pages financial aid tool guide
    helpPageFinancialAidToolFig31:
      '../assets/uwf_assets/dashboard-guide-pics/financial-aid-tool-guide/Figure31.png',
    helpPageFinancialAidToolFig31a:
      '../assets/uwf_assets/dashboard-guide-pics/financial-aid-tool-guide/Figure31a.png',
    helpPageFinancialAidToolFig32:
      '../assets/uwf_assets/dashboard-guide-pics/financial-aid-tool-guide/Figure32.png',

    // Help pages apr graduation summary guide
    helpPageAprGraduationSummaryFig34:
      '../assets/uwf_assets/dashboard-guide-pics/apr-graduation-summary-guide/Figure34.png',
    helpPageAprGraduationSummaryFig35:
      '../assets/uwf_assets/dashboard-guide-pics/apr-graduation-summary-guide/Figure35.png',
    helpPageAprGraduationSummaryFig36:
      '../assets/uwf_assets/dashboard-guide-pics/apr-graduation-summary-guide/Figure36.png',
    helpPageAprGraduationSummaryFig37:
      '../assets/uwf_assets/dashboard-guide-pics/apr-graduation-summary-guide/Figure37.png',
    helpPageAprGraduationSummaryFig38:
      '../assets/uwf_assets/dashboard-guide-pics/apr-graduation-summary-guide/Figure38.png',
    helpPageAprGraduationSummaryFig38a:
      '../assets/uwf_assets/dashboard-guide-pics/apr-graduation-summary-guide/Figure38a.png',

    // Help pages apr graduation summary guide
    helpPageAprGraduationSummaryFig34External:
      '../assets/uwf_assets/dashboard-guide-pics/apr-graduation-summary-external-guide/Figure34_External.png',
    helpPageAprGraduationSummaryFig35External:
      '../assets/uwf_assets/dashboard-guide-pics/apr-graduation-summary-external-guide/Figure35_External.png',
    helpPageAprGraduationSummaryFig36External:
      '../assets/uwf_assets/dashboard-guide-pics/apr-graduation-summary-external-guide/Figure36_External.png',
    helpPageAprGraduationSummaryFig37External:
      '../assets/uwf_assets/dashboard-guide-pics/apr-graduation-summary-external-guide/Figure37_External.png',
    helpPageAprGraduationSummaryFig38aExternal:
      '../assets/uwf_assets/dashboard-guide-pics/apr-graduation-summary-external-guide/Figure38a_External.png',

    // Help pages entry exit flow guide
    helpPageEntryExitFlow39:
      '../assets/uwf_assets/dashboard-guide-pics/entry-exit-flow-guide/Figure39.png',
    helpPageEntryExitFlow40:
      '../assets/uwf_assets/dashboard-guide-pics/entry-exit-flow-guide/Figure40.png',
    helpPageEntryExitFlow41:
      '../assets/uwf_assets/dashboard-guide-pics/entry-exit-flow-guide/Figure41.png',

    // Help pages entry exit flow external guide
    helpPageEntryExitFlow39External:
      '../assets/uwf_assets/dashboard-guide-pics/entry-exit-flow-external-guide/Figure39_External.png',
    helpPageEntryExitFlow40External:
      '../assets/uwf_assets/dashboard-guide-pics/entry-exit-flow-external-guide/Figure40_External.png',
    helpPageEntryExitFlow40aExternal:
      '../assets/uwf_assets/dashboard-guide-pics/entry-exit-flow-external-guide/Figure40a_External.png',
    helpPageEntryExitFlow41External:
      '../assets/uwf_assets/dashboard-guide-pics/entry-exit-flow-external-guide/Figure41_External.png',

    // Help pages FTIC Course DWF & APR
    helpPageFTICCourseDWFAPR42:
      '../assets/uwf_assets/dashboard-guide-pics/ftic-course-dwf-apr-guide/Figure42.png',
    helpPageFTICCourseDWFAPR43:
      '../assets/uwf_assets/dashboard-guide-pics/ftic-course-dwf-apr-guide/Figure43.png',
    helpPageFTICCourseDWFAPR44:
      '../assets/uwf_assets/dashboard-guide-pics/ftic-course-dwf-apr-guide/Figure44.png',
    helpPageFTICCourseDWFAPR44a:
      '../assets/uwf_assets/dashboard-guide-pics/ftic-course-dwf-apr-guide/Figure44a.png',
    helpPageFTICCourseDWFAPR44b:
      '../assets/uwf_assets/dashboard-guide-pics/ftic-course-dwf-apr-guide/Figure44b.png',

    // Help pages FTIC Course DWF & APR External
    helpPageFTICCourseDWFAPRExternal42:
      '../assets/uwf_assets/dashboard-guide-pics/ftic-course-dwf-apr-external-guide/Figure42_External.png',
    helpPageFTICCourseDWFAPRExternal43:
      '../assets/uwf_assets/dashboard-guide-pics/ftic-course-dwf-apr-external-guide/Figure43_External.png',
    helpPageFTICCourseDWFAPRExternal44:
      '../assets/uwf_assets/dashboard-guide-pics/ftic-course-dwf-apr-external-guide/Figure44_External.png',
    helpPageFTICCourseDWFAPRExternal44a:
      '../assets/uwf_assets/dashboard-guide-pics/ftic-course-dwf-apr-external-guide/Figure44a_External.png',

    // Help pages Critical Course Score
    helpPageCoursesAnalysis45:
      '../assets/uwf_assets/dashboard-guide-pics/courses-analysis-guide/Figure45.png',
    helpPageCoursesAnalysis46:
      '../assets/uwf_assets/dashboard-guide-pics/courses-analysis-guide/Figure46.png',
    helpPageCoursesAnalysis47:
      '../assets/uwf_assets/dashboard-guide-pics/courses-analysis-guide/Figure47.png',
    helpPageCoursesAnalysis48:
      '../assets/uwf_assets/dashboard-guide-pics/courses-analysis-guide/Figure48.png',
    helpPageCoursesAnalysis49:
      '../assets/uwf_assets/dashboard-guide-pics/courses-analysis-guide/Figure49.png',
    helpPageCoursesAnalysis50:
      '../assets/uwf_assets/dashboard-guide-pics/courses-analysis-guide/Figure50.png',
    helpPageCoursesAnalysis51:
      '../assets/uwf_assets/dashboard-guide-pics/courses-analysis-guide/Figure51.png',

    // Help pages new applicants guide
    helpPageNewAplicants52:
      '../assets/uwf_assets/dashboard-guide-pics/new-applicants-guide/Figure52.png',
    helpPageNewAplicants53:
      '../assets/uwf_assets/dashboard-guide-pics/new-applicants-guide/Figure53.png',
    helpPageNewAplicants54:
      '../assets/uwf_assets/dashboard-guide-pics/new-applicants-guide/Figure54.png',

    // Help pages three year graduation rate guide
    helpPageThreeYearGraduationRate55:
      '../assets/uwf_assets/dashboard-guide-pics/three-year-graduation-rate-guide/Figure55_External.png',
    helpPageThreeYearGraduationRate56:
      '../assets/uwf_assets/dashboard-guide-pics/three-year-graduation-rate-guide/Figure56_External.png',
    helpPageThreeYearGraduationRate57:
      '../assets/uwf_assets/dashboard-guide-pics/three-year-graduation-rate-guide/Figure57_External.png',
    helpPageThreeYearGraduationRate58:
      '../assets/uwf_assets/dashboard-guide-pics/three-year-graduation-rate-guide/Figure58_External.png',
    helpPageThreeYearGraduationRate58a:
      '../assets/uwf_assets/dashboard-guide-pics/three-year-graduation-rate-guide/Figure58a_External.png',

    // Help pages transfer overview guide
    helpPageTransferOverview59:
      '../assets/uwf_assets/dashboard-guide-pics/transfer-overview-guide/Figure59.png',
    helpPageTransferOverview60:
      '../assets/uwf_assets/dashboard-guide-pics/transfer-overview-guide/Figure60.png',
    helpPageTransferOverview61:
      '../assets/uwf_assets/dashboard-guide-pics/transfer-overview-guide/Figure61.png',
    helpPageTransferOverview62:
      '../assets/uwf_assets/dashboard-guide-pics/transfer-overview-guide/Figure62.png',

    // Help pages Transfer Enrollment Trends Guide
    helpPageTransferEnrollmentTrends63:
      '../assets/uwf_assets/dashboard-guide-pics/transfer-enrollment-trends-guide/Figure63.png',
    helpPageTransferEnrollmentTrends64:
      '../assets/uwf_assets/dashboard-guide-pics/transfer-enrollment-trends-guide/Figure64.png',
    helpPageTransferEnrollmentTrends65:
      '../assets/uwf_assets/dashboard-guide-pics/transfer-enrollment-trends-guide/Figure65.png',
    helpPageTransferEnrollmentTrends65a:
      '../assets/uwf_assets/dashboard-guide-pics/transfer-enrollment-trends-guide/Figure65a.png',
    helpPageTransferEnrollmentTrends65b:
      '../assets/uwf_assets/dashboard-guide-pics/transfer-enrollment-trends-guide/Figure65b.png',

    // Help page guide Course Explorer Icons
    helppageLogoStudentCohortProfile:
      '../assets/uwf_assets/homepage-success-metrics-pics/studentCohortProfile.png',
    helppageLogoAtRisk:
      '../assets/uwf_assets/homepage-success-metrics-pics/atRiskStudent.png',

    // Navigate support page pictures
    navSupportFigure1:
      '../assets/uwf_assets/navigation-support-pics/NavSupportPic1.png',
    navSupportFigure2:
      '../assets/uwf_assets/navigation-support-pics/NavSupportPic2.png',
    navSupportFigure3:
      '../assets/uwf_assets/navigation-support-pics/NavSupportPic3.png',
    navSupportFigure4:
      '../assets/uwf_assets/navigation-support-pics/NavSupportPic4.png',
    navSupportFigure5:
      '../assets/uwf_assets/navigation-support-pics/NavSupportPic5.png',
    navSupportFigure6:
      '../assets/uwf_assets/navigation-support-pics/NavSupportPic6.png',

    // Help page guide Course Explorer Icons
    helppageLogoCourseCombinations:
      '../assets/uwf_assets/homepage-success-metrics-pics/courseCombinations.png',
    helppageLogoCourseRank:
      '../assets/uwf_assets/homepage-success-metrics-pics/courseRank.png',
    helppageLogoPrerequisiteImpact:
      '../assets/uwf_assets/homepage-success-metrics-pics/prerequisiteImpact.png',
    helppageLogoProgramBottleneck:
      '../assets/uwf_assets/homepage-success-metrics-pics/programBottleneckCourses.png',

    // Help page guide Course Recommender/Estimations Icons
    helppageLogoCourseRecommender:
      '../assets/uwf_assets/homepage-success-metrics-pics/courseRecommender.png',
    helppageLogoCourseGradeEstimation:
      '../assets/uwf_assets/homepage-success-metrics-pics/courseGradeEstimation.png',

    // Help page guide Financial Aid Icons
    helppageLogoFinancialAidTool:
      '../assets/uwf_assets/homepage-financial-aid-pics/financialAidTool.png',
    helppageLogoTypesOfFinancialAid:
      '../assets/uwf_assets/homepage-financial-aid-pics/typesOfFinancialAid.png',

    // Help page guide Admin Support icons
    helppageLogoAPRGradSum:
      '../assets/uwf_assets/homepage-admin-support-pics/aprGraduationSummary.png',
    helppageLogoExitGraphCourses:
      '../assets/uwf_assets/homepage-admin-support-pics/exitGraphCourseGradesScore.png',
    helppageLogoNewApplicants:
      '../assets/uwf_assets/homepage-admin-support-pics/newApplicants.png',
    helppageLogoTransferOverview:
      '../assets/uwf_assets/homepage-admin-support-pics/transferOverview.png',

    // About pamlab building pictures
    building4Pic: '../assets/uwf_assets/building-homepage-pics/hmcse_bldg.jpeg',
    building76aPic: '../assets/uwf_assets/building-homepage-pics/cob_bldg.jpeg',
    buildingLabScienceAnnexPic:
      '../assets/uwf_assets/building-homepage-pics/hmcse_bldg_2.jpeg',
    buildingDarGoodenCenterPic:
      '../assets/uwf_assets/building-homepage-pics/ukcoh_bldg.jpeg',
    buildingArcheologyPic:
      '../assets/uwf_assets/building-homepage-pics/cashh_bldg.webp',
    building86Pic: '../assets/uwf_assets/building-homepage-pics/ceps_bldg.webp',

    // Landing page pictures
    mainLandingPagePic:
      '../assets/uwf_assets/landing-page-pic/landing-page-main-pic.png',
    pieChartLandingPagePic:
      '../assets/uwf_assets/landing-page-pic/pie-chart-landing-page.png',

    // Retention and graduation pictures
    retentionGraduation1Pic:
      '../assets/uwf_assets/landing-page-pic/retention-and-graduation-pic1.png',
    retentionGraduation2Pic:
      '../assets/uwf_assets/landing-page-pic/retention-and-graduation-pic2.png',
    retentionGraduation3Pic:
      '../assets/uwf_assets/landing-page-pic/retention-and-graduation-pic3.png',
    retentionGraduation4Pic:
      '../assets/uwf_assets/landing-page-pic/retention-and-graduation-pic4.png',

    // Risk groups  pictures
    riskGroups1Pic:
      '../assets/uwf_assets/landing-page-pic/risk-groups-pic1.png',
    riskGroups2Pic:
      '../assets/uwf_assets/landing-page-pic/risk-groups-pic2.png',
    riskGroups3Pic:
      '../assets/uwf_assets/landing-page-pic/risk-groups-pic3.png',

    // Future interventions  pictures
    futureInterventions1Pic:
      '../assets/uwf_assets/landing-page-pic/future-interventions-pic1.png',
    futureInterventions2Pic:
      '../assets/uwf_assets/landing-page-pic/future-interventions-pic2.png',

    // Access individual  pictures
    accessIndividual1Pic:
      '../assets/uwf_assets/landing-page-pic/assess-individual-pic1.png',
    accessIndividual2Pic:
      '../assets/uwf_assets/landing-page-pic/assess-individual-pic2.png',
    accessIndividual3Pic:
      '../assets/uwf_assets/landing-page-pic/assess-individual-pic3.png',

    // At risk student pictures
    atRiskStudent1Pic:
      '../assets/uwf_assets/landing-page-pic/at-risk-student-pic1.png',
    atRiskStudent2Pic:
      '../assets/uwf_assets/landing-page-pic/at-risk-student-pic2.png',
    atRiskStudent3Pic:
      '../assets/uwf_assets/landing-page-pic/at-risk-student-pic3.png',

    // Workable course combinations pictures
    workableCourseCombinations1Pic:
      '../assets/uwf_assets/landing-page-pic/course-combinations-pic1.png',
    workableCourseCombinations2Pic:
      '../assets/uwf_assets/landing-page-pic/course-combinations-pic2.png',
    workableCourseCombinations3Pic:
      '../assets/uwf_assets/landing-page-pic/course-combinations-pic3.png',

    // Future GPA and time to graduation pictures
    futureProjectPic:
      '../assets/uwf_assets/landing-page-pic/future-projection-pic.png',

    // Login page picture
    loginPagePic: '../assets/uwf_assets/login-page-pics/UWF_Logo_Login_2.0.png',

    // Profile page icon
    profilePageIcon: '../assets/uwf_assets/profile-page-pics/userProfile.png',

    // About page icons
    gearIcon: '../assets/uwf_assets/aboutpage-pics/gear.png',
    arrowsRotateIcon: '../assets/uwf_assets/aboutpage-pics/arrows-rotate.png',

    // Navbar logos
    webScreenNavBarPic:
      '../assets/uwf_assets/uwf-navbar-logo-pics/PamLabLogo1.png',
    phoneScreenNavBarPic:
      '../assets/uwf_assets/uwf-navbar-logo-pics/pamlab-mobile.png',

    // Tab Icon
    favicon: 'assets/uwf_assets/favicon.png',
  },
  carousel_images: [
    {
      path: '../assets/uwf_assets/building-homepage-pics/hmcse_bldg.jpeg',
      name: 'College of Science and Engineering',
    },
    {
      path: '../assets/uwf_assets/building-homepage-pics/cob_bldg.jpeg',
      name: 'College of Business',
    },
    {
      path: '../assets/uwf_assets/building-homepage-pics/hmcse_bldg_2.jpeg',
      name: 'College of Science and Engineering 2',
    },
    {
      path: '../assets/uwf_assets/building-homepage-pics/ukcoh_bldg.jpeg',
      name: 'Usha Kundu, MD College of Health',
    },
    {
      path: '../assets/uwf_assets/building-homepage-pics/cashh_bldg.webp',
      name: 'College of Arts, Social Sciences and Humanities',
    },
    {
      path: '../assets/uwf_assets/building-homepage-pics/ceps_bldg.webp',
      name: 'College of Education and Professional Studies',
    },
  ],
  colors: {
    primary: '#004C97',
    secondary: '#97C800',
    second_secondary: '#a4cf4096',
    accent: '#B6ADA5',
    svg_icon_primary: '#009CDE',
    svg_icon_secondary: '#000000',
    tool_btn_active: '#009cde',
    tool_btn_inactive: '#99c7e5e0',
    chip_bg: '#97C800',
    chip_text: '#000',
    refresh_btn: '#97C800',
    view_student_btn: '#8DC8E8',
    add_course_btn: '#97C800',
    add_course_btn_text: '#000',
  },
};
